const colors = {
  primary: '#DA251D',
  blue: '#DA251D',
  green: '#2BB36F',
  orange: '#FF5448'
}

export default colors